import { Typography } from '@mui/material'
import { GroupRow, GroupTitleFormatter, RenderGroupTitle } from '../types'

interface GroupTitleProps {
  row: GroupRow
  groupTitleFormatter?: GroupTitleFormatter
  externalRenderGroupTitle?: RenderGroupTitle
}

export function GroupTitle({
  row,
  groupTitleFormatter,
  externalRenderGroupTitle
}: GroupTitleProps) {
  // Use external direct renderer if provided
  if (externalRenderGroupTitle) {
    return externalRenderGroupTitle(row)
  }

  // Use formatter if provided
  if (groupTitleFormatter) {
    return groupTitleFormatter(
      row.groupValue,
      row.childCount,
      row.groupField,
      row
    )
  }

  // Default rendering
  return (
    <Typography variant='body2'>
      {row.groupValue} ({row.childCount})
    </Typography>
  )
}
